import{b as t}from"./chunk-ZAMHKQQC.mjs";import"./chunk-J6D5YEY6.mjs";function e(){return t().setDictateState}export{e as useSetDictateState};
/*! For license information please see botframework-webchat-api.internal.mjs.LEGAL.txt */
//# sourceMappingURL=botframework-webchat-api.internal.mjs.map